import { githubRepositoryNameSchema } from 'common/github/githubValidation';
import { z } from 'zod';

//
// StackConfig (Diploi.yaml) types and validation
//

export interface StackConfigComponent {
  name: string;
  identifier: string;
  package: string;
  env?: {
    include?: string | string[];
    exclude?: string | string[];
  };
}

const envPathSchema = z.string().regex(/^[a-zA-Z0-9.*:_-]*$/g);

const stackConfigComponentSchema: z.ZodType<StackConfigComponent[] | undefined> = z
  .array(
    z.strictObject({
      name: z.string(),
      identifier: githubRepositoryNameSchema,
      package: z.string(),
      env: z
        .object({
          include: z.union([envPathSchema, z.array(envPathSchema)]).optional(),
          exclude: z.union([envPathSchema, z.array(envPathSchema)]).optional(),
        })
        .optional(),
    })
  )
  .optional();

export type StackConfig = {
  diploiVersion: 'v1.0';
  name?: string;
  description?: string;
  components?: StackConfigComponent[];
  addons?: StackConfigComponent[];
};

export const stackConfigSchema: z.ZodType<StackConfig> = z.strictObject({
  diploiVersion: z.literal('v1.0'),
  name: z.string().optional(),
  description: z.string().optional(),
  components: stackConfigComponentSchema,
  addons: stackConfigComponentSchema,
});

export type StackConfigErrorCode =
  | 'yaml error'
  | 'package url error'
  | 'config load failed'
  | 'unexpected error'
  | 'validation error'
  | 'component error';
